/**
 * OrbDocCoreConceptsEntitiesAROrbDocCoreConceptsEntitiesARPage
 *
 * Page component for OrbDocCoreConceptsEntitiesAROrbDocCoreConceptsEntitiesARPage
 * Path: /ar/docs/core-concepts/entities
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocCoreConceptsEntitiesARDocScreenView as __OrbDocCoreConceptsEntitiesARDocScreenView } from '@/components/traits/OrbDocCoreConceptsEntitiesARDocScreenView';
import { OrbDocCoreConceptsEntitiesARDocAnalyticsView as __OrbDocCoreConceptsEntitiesARDocAnalyticsView } from '@/components/traits/OrbDocCoreConceptsEntitiesARDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbDocCoreConceptsEntitiesAROrbDocCoreConceptsEntitiesARPageProps {
  // Add any page-level props here
}

export function OrbDocCoreConceptsEntitiesAROrbDocCoreConceptsEntitiesARPage(_props: OrbDocCoreConceptsEntitiesAROrbDocCoreConceptsEntitiesARPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"الكيانات","description":"البيانات التي يملكها المداريّ، وأين تُخزَّن، ومن يحق له قراءتها أو تغييرها.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs/core-concepts/entities"},{"locale":"ar","path":"/ar/docs/core-concepts/entities"},{"locale":"sl","path":"/sl/docs/core-concepts/entities"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocCoreConceptsEntitiesARDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocCoreConceptsEntitiesARDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbDocCoreConceptsEntitiesAROrbDocCoreConceptsEntitiesARPage;
